// English UI strings (v1). Every user-visible string goes through t() so Hindi can ship later (OPEN-Q27).
export const en = {
  "app.portal": "AawazAI Connect",
  "app.admin": "AawazAI Admin",
  "login.title": "Sign in",
  "login.phone": "Mobile number",
  "login.send": "Send code on WhatsApp",
  "login.sms": "Send by SMS instead",
  "login.code": "4-digit code",
  "login.verify": "Verify",
  "login.sent": "If this number is registered, a code has been sent.",
  "login.totp": "Authenticator code",
  "login.totp_enrol": "Scan this with your authenticator app (Google Authenticator, Authy, 1Password), or type the key under it. Then enter the 6-digit code it shows.",
  "nav.dashboard": "Dashboard",
  "nav.clients": "Clients",
  "nav.documents": "Documents",
  "nav.review": "Review queue",
  "nav.quarantine": "Held back",
  "nav.whatsapp": "WhatsApp",
  "nav.connections": "Connections",
  "nav.mirror": "Mirror",
  "nav.activity": "Activity",
  "nav.settings": "Settings",
  "nav.logout": "Log out",
  "common.loading": "Loading…",
  "common.empty": "Nothing here yet.",
  "common.more": "Load more",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.search": "Search",
  "review.accept": "Accept",
  "review.quarantine": "Hold back",
  "review.set_client": "Set client",
  "review.set_type": "Set doc type",
  "review.set_period": "Set period",
  "review.unlock": "Unlock",
  "review.shortcuts": "Keys: j/k move · x select · a accept · q hold back · o open",
  "doc.preview_blocked": "Preview is not available for this file.",
  "quarantine.expires": "Auto-deletes in",
  "settings.members": "Members",
  "settings.api": "API keys",
  "settings.webhooks": "Webhooks",
  "settings.policy": "Policy",
  "settings.audit": "Audit log",
  "settings.support": "Support access",
  "settings.data": "Data export & erasure",
} as const;

export type MessageKey = keyof typeof en;
